import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import 'moment/locale/pt-br';

import { CEP_PATTERN } from '../../../../consts/patterns';

import { Input, InputMask, Select } from '../../../../components/Form';

import schema from './schema';

import { CAMPO_OBRIGATORIO, UFS_OPTIONS } from '../../../../consts/common';
import { getEnderecoByCep } from '../../../../utils/getEnderecoByCEP';

function EnderecoForm({ onChange, onValid }) {
  const {
    control,
    reset,
    getValues,
    watch,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    const subscription = watch(onChange);
    return () => subscription.unsubscribe();
  }, [watch, onChange]);

  useEffect(() => {
    onValid?.(isValid);
  }, [isValid, onValid, errors]);

  async function handleCepBlur(cepValue) {
    if (cepValue) {
      const response = await getEnderecoByCep(cepValue);

      const currentValues = getValues();

      reset({
        ...response,
        numero: currentValues.numero,
        complemento: currentValues.complemento,
      });
    }
  }

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <InputMask
            control={control}
            id="cep"
            name="cep"
            label="CEP"
            variant="outlined"
            pattern={CEP_PATTERN}
            error={!!errors?.cep}
            helperText={errors?.cep ? errors.cep.message : CAMPO_OBRIGATORIO}
            onBlur={(event) => {
              handleCepBlur(event?.nativeEvent?.target?.value);
            }}
          />
        </Grid>
        <Input control={control} id="ibge" name="ibge" hidden />
        <Grid item xs={6}>
          <Input
            control={control}
            id="Logradouro"
            name="logradouro"
            label="Logradouro"
            placeholder="Logradouro"
            variant="outlined"
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <Input
            control={control}
            id="numero"
            name="numero"
            label="Número"
            placeholder="Número"
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <Input
            control={control}
            id="complemento"
            name="complemento"
            label="Complemento"
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            placeholder="Complemento"
            fullWidth
          />
        </Grid>
        <Grid item xs={6}>
          <Input
            control={control}
            id="bairro"
            name="bairro"
            label="Bairro"
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            placeholder="Bairro"
            fullWidth
          />
        </Grid>
        <Grid item xs={6}>
          <Input
            control={control}
            id="cidade"
            name="cidade"
            label="Cidade"
            placeholder="Cidade"
            variant="outlined"
            error={!!errors?.cidade}
            helperText={
              errors?.cidade ? errors.cidade.message : CAMPO_OBRIGATORIO
            }
            InputLabelProps={{
              shrink: true,
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={2}>
          <Select
            control={control}
            id="estado"
            name="estado"
            label="Estado"
            options={UFS_OPTIONS}
            error={!!errors?.estado}
            helperText={errors?.estado ? errors.estado.message : ''}
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            fullWidth
          />
        </Grid>
      </Grid>
    </>
  );
}

EnderecoForm.propTypes = {
  onChange: PropTypes.func,
  onValid: PropTypes.func,
};

export default EnderecoForm;
